import isEmpty from "lodash/isEmpty";
import { Types } from "@grandvisionhq/graphql";
const mapPaymentDataToSummaries = (paymentData) => {
  const paymentDataResponse = paymentData?.response;
  if (!paymentData || !paymentDataResponse?.customerDetails || !paymentDataResponse?.shippingAddress) {
    return { isDataValid: false };
  }
  const { addressLine1, addressLine2, city, postalCode, state, countryCode } = paymentDataResponse.shippingAddress;
  const {
    firstName: customerFirstName,
    lastName: customerLastName,
    email,
    phone
  } = paymentDataResponse.customerDetails;
  const firstName = customerFirstName || "";
  const lastName = customerLastName || "";
  const addressDetails = {
    ...!isEmpty(addressLine1) ? { additionalStreetInfo: addressLine1 || "" } : null,
    ...!isEmpty(addressLine1) ? { additionalAddressInfo: addressLine2 || "" } : null,
    firstName,
    lastName,
    city: city || "",
    postalCode: postalCode || "",
    state: state || "",
    countryCode,
    email,
    phone: phone || ""
  };
  return {
    isDataValid: true,
    contactDetails: {
      values: {
        firstName,
        lastName,
        email,
        phone: phone || "",
        customerType: Types.CheckoutCustomerType.B2C
      }
    },
    addresses: {
      values: {
        billingAddress: addressDetails,
        deliveryAddress: addressDetails,
        isAddressesEqual: true
      }
    }
  };
};
export {
  mapPaymentDataToSummaries
};
//# sourceMappingURL=map-payment-data-to-summaries.js.map
